import PenerimaanBarangApi from "./PenerimaanBarangApi"

export default PenerimaanBarangApi